import { Component, OnInit } from '@angular/core';
import { Message, ConfirmationService } from 'primeng/api';
import { saveAs } from 'file-saver';

import { QaSessionService, QaSession, Computer } from '../../services/GI.Web.Services.g';
import { ErrorHandling } from '../../ErrorHandling';
import { RdpService } from '../../services/rdp.service';
import { IsAdmin } from '../../guards/isAdmin';

// TODO: loading indicators

@Component({
  selector: 'app-qa-sessions-list',
  templateUrl: './qa-sessions-list.component.html',
  styleUrls: ['./qa-sessions-list.component.css']
})
export class QaSessionsListComponent implements OnInit {

  constructor(
    private qaSessionService: QaSessionService,
    private adminGuard: IsAdmin,
    private confirmationService: ConfirmationService,
    private rdpService: RdpService
    ) { }

  public sessions: QaSession[];
  public showDialog = false;
  public disableSave = false;
  public newSession: QaSession;
  public messages: Message[];
  public dialogMessages: Message[];

  async ngOnInit() {
    // HACK: Is this canActivate() call necessary? Why?
    this.adminGuard.canActivate();
    await this.getSessionList();
  }

  private async getSessionList() {
    try {
      this.sessions = await this.qaSessionService.getAll().toPromise();
    } catch (error) {
      this.messages = ErrorHandling.getErrorMessages(error, 'Error fetching list of QA sessions:');
    }
  }

  public showDialogToAdd(): void {
    this.newSession = new QaSession();
    this.dialogMessages = null;
    this.disableSave = false;
    this.showDialog = true;
  }

  public async save() {
    this.dialogMessages = null;
    this.disableSave = true;
    try {
      await this.qaSessionService.createQaSession(this.newSession).toPromise();
      this.showDialog = false;
      await this.getSessionList();
    } catch (error) {
      this.dialogMessages = ErrorHandling.getErrorMessages(error);
    }
    this.disableSave = false;
  }

  public delete(session: QaSession) {
    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      icon: 'fa fa-exclamation-triangle',
      message: `Are you sure you you want to permanently delete the session and resources for '${session.name}'?`,
      accept: () => this.deleteConfirmed(session)
    });
  }

  async deleteConfirmed(session: QaSession): Promise<void> {
    try {
      await this.qaSessionService.delete(session).toPromise();
      await this.getSessionList();
    } catch (error) {
      this.messages = ErrorHandling.getErrorMessages(error, 'Error deleting session:');
    }
  }

  async connect(session: QaSession) {
    try {
      const computers = await this.qaSessionService.getComputers(session).toPromise();
      this.buildRdpFile(computers[0]);
    } catch (error) {
      this.messages = ErrorHandling.getErrorMessages(error, 'Error getting VM information:');
    }
  }

  // TODO: Unfactor...
  buildRdpFile(computer: Computer) {
    console.log(computer);
    if (computer && computer.ipAddress) {
      const rdpString = this.rdpService.buildRdpFileAsString(computer, 'ParadiseUser'); // computer.user);
      const blob = new Blob([rdpString], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, this.rdpService.setRdpFileName(computer));
    }
    else {
      this.messages = [{
        severity: 'error',
        summary: 'Cannot download RDP File.',
        detail: 'VM is not ready or information is not known.'
      }];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/qa-sessions-list/qa-sessions-list.component.ts